document.addEventListener("DOMContentLoaded", function () {
  let resizeTimeout;

  function initSaleTimers() {
    document.querySelectorAll(".product-sale-timer-wrapper").forEach(wrapper => {
      const startTime = new Date(wrapper.dataset.start.replace(/-/g, "/")).getTime();
      const endTime = new Date(wrapper.dataset.end.replace(/-/g, "/")).getTime();

      const hoursEl = wrapper.querySelector(".product-timer-hours");
      const minutesEl = wrapper.querySelector(".product-timer-minutes");
      const secondsEl = wrapper.querySelector(".product-timer-seconds");
      const progressBar = wrapper.querySelector(".product-sale-progress-bar");

      /* Clear previous interval if exists */
      if (wrapper.timerInterval) {
        clearInterval(wrapper.timerInterval);
      }

      function updateTimer() {
        const now = new Date().getTime();

        /* Hide if not started or ended */
        if (now < startTime || now >= endTime) {
          wrapper.style.display = "none";
          clearInterval(wrapper.timerInterval);
          return;
        }

        wrapper.style.display = "block";

        const totalDuration = endTime - startTime;
        const timeLeft = endTime - now;
        const timePassed = now - startTime;

        const hours = Math.floor(timeLeft / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        hoursEl.textContent = String(hours).padStart(2, "0");
        minutesEl.textContent = String(minutes).padStart(2, "0");
        secondsEl.textContent = String(seconds).padStart(2, "0");

        const progressPercent = Math.min((timePassed / totalDuration) * 100, 100);
        progressBar.style.width = progressPercent + "%";
      }

      updateTimer();
      wrapper.timerInterval = setInterval(updateTimer, 1000);
    });
  }

  /* Initial run */
  initSaleTimers();

  /* Re-initialize on screen resize (debounced) */
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initSaleTimers, 300);
  });
});
